<main class="info-page">
  <nav class="breadcrumbs" aria-label="Breadcrumb">
    <a routerLink="/">Home</a>
    <span aria-hidden="true">/</span>
    <span>{{ page.title }}</span>
  </nav>

  <header class="info-hero">
    <p class="eyebrow">{{ page.eyebrow }}</p>
    <h1>{{ page.title }}</h1>
    <p class="info-lede">{{ page.description }}</p>
    @if (page.updated) {
      <p class="updated">Last updated: {{ page.updated }}</p>
    }
  </header>

  <div class="info-layout">
    <article class="info-content">
      @for (section of page.sections; track section.title; let index = $index) {
        <section class="info-section">
          <span class="section-number">{{
            (index + 1).toString().padStart(2, "0")
          }}</span>
          <h2>{{ section.title }}</h2>
          @for (paragraph of section.paragraphs ?? []; track paragraph) {
            <p>{{ paragraph }}</p>
          }
          @if (section.bullets?.length) {
            <ul>
              @for (bullet of section.bullets; track bullet) {
                <li>{{ bullet }}</li>
              }
            </ul>
          }
        </section>
      }
    </article>

    <aside class="info-aside">
      @if (page.email) {
        <section class="contact-card">
          <span class="aside-label">Need help?</span>
          <h2>Talk to {{ appName }}</h2>
          <p>
            For questions, feedback, or safety concerns, email our support team.
          </p>
          <a class="email-link" [href]="'mailto:' + page.email">{{
            page.email
          }}</a>
        </section>
      }
      @if (page.address) {
        <section class="address-card">
          <span class="aside-label">Our address</span>
          <address>
            @for (line of page.address; track line) {
              <span>{{ line }}</span>
            }
          </address>
        </section>
      }
      <a class="aside-cta" routerLink="/chat"
        >Start a conversation <span aria-hidden="true">&#8594;</span></a
      >
    </aside>
  </div>
</main>
